import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialog-alert-select-condition-monitor',
    templateUrl: './dialog-alert-select-condition-monitor.component.html',
    styleUrls: ['./dialog-alert-select-condition-monitor.component.scss'],
    standalone: false
})
export class DialogAlertSelectConditionMonitorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
